const socket = window.electronLibs.socket;

export const publishMessageToRedis = async (type: any, raw: any, redisAddress?: any, roomId?: string) => {
  await socket.publishMessage(type, raw, redisAddress, roomId);
};

export const subscribeToRedisTopic = async (roomId: string) => {
  await socket.subscribeToTopic(roomId);
};

export const setRedisChannel = async (roomId: string) => {
  await socket.setChannel(roomId);
};
